import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

const httpLink = createHttpLink({
  // Keep this relative so the browser calls the frontend origin; the dev
  // proxy (or production reverse proxy) forwards /graphql to the backend.
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || "/graphql",
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const access = localStorage.getItem("accessToken");
  const refresh = localStorage.getItem("refreshToken");
  const token = access || refresh;
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${access} ${refresh}` : "",
    },
  };
});

const errorLink = onError(({ graphQLErrors }) => {
  // const token = useToken();
  if (graphQLErrors)
    graphQLErrors.map(({ message }) => {
      if (message === "NOT_AUTHORIZED") {
        // every 401/unauthorized error will be caught here and update the global local state
        // Cookies.remove(AUTH_TOKEN_KEY);
        //   token.removeToken();
        //   Router.replace(Routes.home);
      }
      return message;
    });
});

export const client = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache(),
});
